// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.graph-canvas-container {
  position: relative;
  width: 100%;
  height: 100%;
  overflow: auto;
  background: #1a1a1a;
  background-image: 
    linear-gradient(90deg, rgba(255,255,255,0.03) 1px, transparent 1px),
    linear-gradient(rgba(255,255,255,0.03) 1px, transparent 1px);
  background-size: 20px 20px;
}

.graph-canvas-svg {
  position: absolute;
  top: 0;
  left: 0;
  pointer-events: none;
  z-index: 1;
}

.graph-nodes-container {
  position: relative;
  z-index: 2;
  pointer-events: none;
}

.graph-nodes-container > * {
  pointer-events: all;
}

`, "",{"version":3,"sources":["webpack://./src/graph_components/GraphCanvas.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,cAAc;EACd,mBAAmB;EACnB;;gEAE8D;EAC9D,0BAA0B;AAC5B;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,oBAAoB;EACpB,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;AACrB","sourcesContent":[".graph-canvas-container {\n  position: relative;\n  width: 100%;\n  height: 100%;\n  overflow: auto;\n  background: #1a1a1a;\n  background-image: \n    linear-gradient(90deg, rgba(255,255,255,0.03) 1px, transparent 1px),\n    linear-gradient(rgba(255,255,255,0.03) 1px, transparent 1px);\n  background-size: 20px 20px;\n}\n\n.graph-canvas-svg {\n  position: absolute;\n  top: 0;\n  left: 0;\n  pointer-events: none;\n  z-index: 1;\n}\n\n.graph-nodes-container {\n  position: relative;\n  z-index: 2;\n  pointer-events: none;\n}\n\n.graph-nodes-container > * {\n  pointer-events: all;\n}\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
